import Class from '@/Class';
import { IDropdownMenuItem } from '#/CoreFrameInterfaces';
import ComponentManager from '@/Management/ComponentManager';

export default class UIInterceptor extends Class {

    constructor() {
        super();

        this.isDisposable = this.paramOrDefault(true);
    }

    public afterStartup(callback: () => void): void {
        callback();
    }

    public afterLogin(callback: () => void): void {
        callback();
    }

    public beforeLoadRootLayout(): void {
    }

    public afterLoadRootLayout(): void {
    }

    public neededDefaultResourceItems(): any {
        return null;
    }

    public beforeLoadMenuTree(rootNode: any): void {
    }

    public beforeLoadNavigationTree(rootNode: any): void {
    }

    public beforeLoadUserDropdownMenu(menuItems: IDropdownMenuItem[]) {
    }

    /**
     * Erzeugt eine neue Instanz eines UIInterceptors anhand einer Komponentenbezeichnung
     */
    public static createInstance(component: string): UIInterceptor {
        let Component = ComponentManager.getUIInterceptor(component) as typeof UIInterceptor;

        if (Component == null) {
            throw 'UIInterceptor-Komponente "' + component + '" wurde nicht gefunden.';
        }

        return new Component();
    }

}